import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GLOBAL } from './global';
import { FilterUrlService } from './filter-url.service';
import 'rxjs/add/operator/map';
import * as moment from 'moment';
import { Tags} from '../model/Tags';

@Injectable()
export class TagsService {
  //url:string = GLOBAL.url+"tags?sort=-prefix";
  url:string = GLOBAL.url+"tags";
  filter:string;

  constructor( private http:HttpClient, private _urlService:FilterUrlService ) {
    this._urlService.filters.subscribe(new_filter => this.filter = new_filter );
  }
  /**
  * Obtiene el listado de 10 elementos.
  * @return listado de clientes o un error.
  */
  public get(){
    return this.http.get(this.url+"?sort=-prefix" ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene todos los datos asociados a un tag
  * @return información relacionada al tag
  */
  public getTagById(tag_id:number){
    return this.http.get(this.url+`?tag_id=${tag_id}` ).map( res => {
      return res;
    });
  }

  public getDataFiltered(filters){
    console.log(filters);
    let url = GLOBAL.url+'tags_distinct'+filters;
    console.log(url);
    return this.http.get(url).map( res => {
        return res;
    });
  }

  /**
  * Obtiene el listado de todos los elementos.
  * @return listado de clientes o un error.
  */
  public getAll(){
    let url = this.url+'?limit=200000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los elementos.
  * @return listado de tags o un error.
  */
  public getAllbyPrefix(){
    let url = GLOBAL.url+'tags_distinct'+this.filter;
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los elementos.
  * @return listado de tags o un error.
  */
  public getAllbyPrefixInProcess(status:number){
    let url = GLOBAL.url+'tags_distinct?sort=-prefix&tag_status_id='+status+'&limit=10000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene un tag, buscado por prefijo y sufijo.
  * @return tag o un error.
  */
  public getOnebyPrefixAndSuffix(p:string,s:string){
    let url = GLOBAL.url+'tags?prefix='+p+'&suffix='+s+'&sort=-id';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de todos los elementos.
  * @return listado de tags o un error.
  */
  public getAllbyPackingInProcess(id:number){
    let url = GLOBAL.url+'tags_distinct?packing_id='+id+'&limit=1000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el prefijo mayor
  * @return listado de clientes o un error.
  */
  public getPrefix(){
    let url = GLOBAL.url+'tags?soft&sort=--prefix&limit=1';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el prefijo mayor
  * @return listado de clientes o un error.
  */
  public getTagsFromPrefix(pr){
    let url = GLOBAL.url+'tags?prefix='+pr+'&sort=+id&limit=91';
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de algunos elementos.
  * @return listado de clientes o un error.
  */
  public getTagsFromStatus(status:number){
    let url = GLOBAL.url+'tags?tag_status_id='+status;
    return this.http.get(url ).map( res => {
      return res;
    });
  }

  /**
  * Obtiene el listado de algunos elementos.
  * @return listado de clientes o un error.
  */
  public getTagsFromPacking(id:number,status:number){
    let url = GLOBAL.url+'tags?packing_id='+id+'&tag_status_id='+status+'&sort=-id&limit=1000';
    return this.http.get(url ).map( res => {
      return res;
    });
  }


  /**
  * Envia un POST para almacenar información.
  * @param  prov información a enviar
  * @return      respuesta de la peticion http
  */
  public save(prov:any){
    //console.log("PROV: ", prov);
    return this.http.post(this.url, prov)
    .map( data => {
      return data;
    });
  }

  /**
  * Envia un POST para almacenar información de varios tags a la vez.
  * @param  prov información a enviar
  * @return      respuesta de la peticion http
  */
  public saveAll(prov:any){
    let url = GLOBAL.url+"all_tags";
    return this.http.post(url, prov)
    .map( data => {
      return data;
    });
  }

  /**
  * Actualiza varios elementos en la base de datos
  * @param  url  url de los elementos que se actualizarán.
  * @param  body ¿?
  * @return      respuesta de la peticion http
  */
  public update(body){
    let url = GLOBAL.url+"all_tags";
    return this.http.put(url, body)
      .map( data => {return data;});
  }

  /**
  * Actualiza varios elementos en la base de datos
  * @param  url  url de los elementos que se actualizarán.
  * @param  body ¿?
  * @return      respuesta de la peticion http
  */
  public deleteAll(body){
    let url = GLOBAL.url+"all_tags_delete";
    return this.http.put(url, body)
      .map( data => {return data;});
  }

  /**
  * Actualiza un elemento en la base de datos
  * @param  url  url del elemento que se actualiza.
  * @param  body ¿?
  * @return      respuesta de la peticion http
  */

  public update2(id:number, body){
    let url = GLOBAL.url+"tags/"+id;
    return this.http.put(url, body)
      .map( data => {return data;});
  }

  /**
  * Actualiza varias cajas (stock_up)
  * @param  url  url del elemento que se actualiza.
  * @param  body ¿?
  * @return      respuesta de la peticion http
  */

 public stock_up(body){
  let url = GLOBAL.url+"stock_up";
  return this.http.put(url, body)
    .map( data => {return data;});
}

  /**
  * Elimina un registro de la base de datos
  * @param  url url del elemento que se elimina
  * @return     respuesta de la peticion http
  */
  public delete(url:string){
    return this.http.delete(url).map( response =>{
      return response;
    });

  }

  /**
  * Transforma una fecha (YYYY-MM-DD 00:00:00) para ser almacenada en una BD.
  * @param  fechas fecha a transformar
  * @return        fecha con el formato (YYYY-MM-DD 00:00:00)
  */
  transformDates(fechas:Date):String{
    let fecha = moment(fechas);
    //2018-02-28 00:00:00
    return (fecha.year()+'-'+(fecha.month()+1)+'-'+fecha.date()+' 00:00:00');
  }

  /**
  * Transforma una fecha (YYYY-MM-DD 00:00:00) para ser almacenada en una BD.
  * @param  fechas fecha a transformar
  * @return        fecha con el formato (YYYY-MM-DD 00:00:00)
  */
  transformDates2(fechas:Date):String{
    let dif1 = fechas.getTimezoneOffset();
    let fecha = moment(fechas);

    if (dif1 > 0) {
      fecha = fecha.subtract(dif1, 'minutes');
    }
    if (dif1 < 0) {
      dif1 *= -1;
      fecha = fecha.add(dif1, 'minutes');
    }
    //2018-02-28 00:00:00
    return (fecha.year()+'-'+(fecha.month()+1)+'-'+(fecha.date()+1)+' 00:00:00');
  }
  //Le agrega dos años a la fecha
  transformDates3(fechas:Date):String{
    let fecha = moment(fechas);
    let fecha2anos = fecha.add(2,'y');

    //2018-02-28 00:00:00
    return (fecha2anos.year()+'-'+(fecha2anos.month()+1)+'-'+(fecha.date())+' 00:00:00');
  }

  /**
  * Transforma un objeto a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData(data:any){
    let p = new Tags(
      data['id'],
      data['suffix'],
      data['prefix'],
      data['code'],
      data['production_order_id'],
      data['lot_id'],
      data['product_id'],
      data['tag_status_id'],
      data['elaboration_date'],
      data['expiration_date'],
      data['comments'],
      data['packing_id'],
      data['box_type_id'],
      data['tag_id']
    );
    return p.getJson();
  }

  /**
  * Transforma un varios objetos a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData2(tags:any[],saldo:any[],tipo_caja:number){
    let p = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    return p.getJson2(tags,saldo,tipo_caja);
  }

  /**
  * Transforma un varios objetos a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformDataUnionSaldo(data:any){
    let tag = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    return tag.getJsonUnionSaldo(data);
  }

  /**
  * Transforma un varios objetos a un formato JSON predefinido en el modelo.
  * @param  data Informacion a transformar.
  * @param  idUnionSaldo Id de la nueva union de saldo.
  * @return      Objeto con el formato JSON correcto.
  */
  transformDataTagsUnionSaldo(data:any[], idUnionSaldo:string){
    let tag = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    return tag.getJsonTagsUnionSaldo(data,idUnionSaldo);
  }

  /**
  * Actualiza un valor del objeto.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData3(packing:any[],id:number){
    let p = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    return p.getJson3(packing,id);
  }

  /**
  * Actualiza un valor del objeto.
  * @param  data Informacion a transformar.
  * @return      Objeto con el formato JSON correcto.
  */
  transformData4(idtag:string){
    let p = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    return p.getJson4(idtag);
  }

  transformData5(idtag:string){
    let p = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    return p.getJson5(idtag);
  }

  transformData6(idtag:string){
    let p = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    return p.getJson6(idtag);
  }

  transformData7(cajas:any[],status){
    let p = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    return p.getJson7(cajas,status);
  }

  transformData8(cajas:any[],status){
    let p = new Tags(0,0,0,0,0,0,0,0,0,0,0,0,0,0);
    return p.getJson8(cajas,status);
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/services/tags.service.ts